import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_16f7b538/src/layouts/default.vue").then(m => m.default || m))
}